import {createAction} from 'redux-actions'
import {removeTask} from "../../entities/actions"

export default function({
    actionTypes: {
        OPEN_TASK_SET,
        TASK_PANEL_ERRORS_ADD,
        TASK_PANEL_ERRORS_SET,
        TASK_PANEL_ERRORS_REMOVE,
        TASK_PANEL_LOADING_SET,
        TASK_PANEL_LOADED_SET,
        TASK_INFO_SET,
        TASK_PANEL_SHOWN_SET,
        TASK_PANEL_TAB_SET,
        TASK_PANEL_LAST_TAB_SET,
        NEED_INITIALIZE_FOCUS_SET,
    }
}) {
    const addTaskPanelErrors = createAction(TASK_PANEL_ERRORS_ADD)
    const setTaskPanelErrors = createAction(TASK_PANEL_ERRORS_SET)
    const removeTaskPanelErrors = createAction(TASK_PANEL_ERRORS_REMOVE)

    const setTaskPanelLoading = createAction(TASK_PANEL_LOADING_SET)

    const setTaskPanelLoaded = createAction(TASK_PANEL_LOADED_SET)

    const setTaskInfo = createAction(TASK_INFO_SET)
    const setTaskPanelShown = createAction(TASK_PANEL_SHOWN_SET)

    const setTaskPanelTab = createAction(TASK_PANEL_TAB_SET)
    const setLastTaskPanelTab = createAction(TASK_PANEL_LAST_TAB_SET)

    const openTaskPanel = () => (dispatch) => {
        dispatch(setTaskPanelShown(true))
    }

    const closeTaskPanel = () => dispatch => {
        dispatch(setTaskPanelShown(false))
    }

    const removeOpenedTask = taskId => (dispatch, getState) => {
        // TODO: taskId should be taken from the store, see TaskPanelContainer.js for reasons why it's not the case now
        // const taskId = getOpenTaskId(getState())
        dispatch(removeTask(taskId))
    }

    const setNeedInitializeFocus = createAction(NEED_INITIALIZE_FOCUS_SET)

    return {
        openTaskPanel,
        closeTaskPanel,
        setTaskInfo,
        addTaskPanelErrors,
        setTaskPanelErrors,
        removeTaskPanelErrors,
        setTaskPanelLoading,
        setTaskPanelLoaded,
        setTaskPanelTab,
        setLastTaskPanelTab,
        setNeedInitializeFocus,
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/task/actionsGenerator.js